import type { TransactionStateUnion, UserAccount } from '@payments/types'
import type { LocationQuery } from '#vue-router'

export enum PspMethodEnum {
    DEPOSIT = 'deposit',
    WITHDRAW = 'withdraw',
    WITHDRAWAL = 'withdrawal',
}

export type PspMethodUnion = `${PspMethodEnum}`

export enum PspEnum {
    PAYMENTIQ = 'PaymentIQ',
    NEMKONTO = 'NemKonto',
    EPAY = 'ePay',
    DUMMY = 'DummyPSP',
    TRUELAYER = 'TrueLayer'
}

export type PspUnion = `${PspEnum}`

export enum IssuerEnum {
    VISA = 'VISA',
    DANKORT = 'Dankort',
    MAESTRO = 'Maestro',
    MASTERCARD = 'Mastercard'
}

export type IssuerUnion = `${IssuerEnum}`

export enum MethodEnum {
    CREDITCARD = 'CreditCard',
    NEMKONTO = 'NemKonto',
    APPLEPAY = 'ApplePay',
    MOBILEPAY = 'MobilePay',
    TRUELAYER = 'TrueLayer',
    PAYPAL = 'Paypal',
    BANK = 'Bank',
    DUMMY = 'DummyMethod',
    GOOGLEPAY = 'GooglePay',
    // Legacy account type still returned by /api/public/cashier/deposit/accounts
    ZIMPLER = 'Zimpler',
}

export type MethodUnion = `${MethodEnum}`

export enum CardTypeEnum {
    DANKORT = 'dankort',
    MAESTRO = 'maestro',
    MASTERCARD = 'mastercard',
    UNKNOWN = 'unknown',
    VISA = 'visa',
}

export type CardTypeUnion = `${CardTypeEnum}`

export enum StateEnum {
    FAILED = 'failed',
    SUCCESSFUL = 'successful',
    PROCESSING = 'processing',
    INCONSISTENT = 'inconsistent',
}

export type StateUnion = `${StateEnum}`

export enum AmountValidationEnum {
    TOO_LOW = 'AMOUNT_TOO_LOW',
    TOO_HIGH = 'AMOUNT_TOO_HIGH',
    MORE_THAN_REMAINING_LIMIT = 'AMOUNT_MORE_THAN_REMAINING_LIMIT',
    LOWER_THAN_FEE = 'AMOUNT_LOWER_THAN_FEE'
}

export type AmountValidationUnion = `${AmountValidationEnum}`

export enum FirstDepositTypeResponseEnum {
    ULTIMATE = 'ultimate',
    SOFT = 'soft',
    RETURNED = 'returned',
}

export type FirstDepositTypeResponseUnion = `${FirstDepositTypeResponseEnum}`

export enum FirstDepositTypeEnum {
    ULTIMATE = 'newndu',
    SOFT = 'softndu',
    RETURNED = 'returnedndu',
}

export type FirstDepositTypeUnion = `${FirstDepositTypeEnum}`

export interface AccountResponse {
    accounts: UserAccount[]
}

export interface ScaRedirect {
    url?: string
}

export interface Receipt {
    account?: UserAccount
    firstDepositType: FirstDepositTypeResponseUnion | null
    amount?: string
    fee?: string
    createdAt?: string
    transactionId?: string
}

export interface ReceiptParams {
    txId: string
    amount?: string
    psp: PspUnion
    transactionType: PspMethodUnion
}

export interface FeeDataParams {
    paymentMethod: MethodUnion
    amount: string
}

export interface FeeResponse {
    fee: string
}

export interface TransactionStatusResponse {
    message?: string
    pspStatusCode?: string
    state: TransactionStateUnion
    statusCode?: string
    firstDepositType: FirstDepositTypeResponseUnion | null
}

export interface DepositGameOptions {
    gameSlug?: string
    gameInstanceId?: string
}

export interface PendingParams extends DepositGameOptions {
    txId?: string
    psp?: PspUnion
    amount?: string
    transactionType?: PspMethodUnion
    isPlaygame?: string
}

export type PendingQueryParams = LocationQuery & PendingParams
